module.exports = __webpack_public_path__ + "static/media/qiwi.f8f3feaa.svg";